import {QRPayloadType} from '@Libraries/qr-code/qr-code.types';

export const QR_TYPE_RAIL_SCROLL_PX = 220;

/** The rail's tabs all drive the one form below them, so every tab points at that panel. */
export const QR_TYPE_TAB_PANEL_ID = 'qr-type-tab-panel';

export const QR_TYPE_TAB_STEP_KEYS: Record<string, number> = {
  ArrowLeft: -1,
  ArrowRight: 1,
};

export interface QRTypeTabsProps {
  types: QRPayloadType[];
  activeType: QRPayloadType;
  onTypeSelect: (type: QRPayloadType) => void;
}

export const QR_TYPE_TAB_ICONS: Record<QRPayloadType, string> = {
  [QRPayloadType.URL]: 'icon-web-page',
  [QRPayloadType.SOCIAL]: 'icon-social-media',
  [QRPayloadType.TEXT]: 'icon-scroll-text',
  [QRPayloadType.EMAIL]: 'icon-envelope',
  [QRPayloadType.PHONE]: 'icon-phone',
  [QRPayloadType.SMS]: 'icon-message',
  [QRPayloadType.WIFI]: 'icon-wifi',
  [QRPayloadType.VCARD]: 'icon-business-card',
  [QRPayloadType.CALENDAR_EVENT]: 'icon-calendar',
  [QRPayloadType.PAYMENT_LINK]: 'icon-cc-generic',
  [QRPayloadType.APP_STORE]: 'icon-mobile',
  [QRPayloadType.MULTIMEDIA]: 'icon-doc',
};
